import * as React from 'react';
import styled from 'styled-components';
import stateSettings from '@state/settings';
import stateUi from '@state/ui';
import H1 from '@src/editor/components/H1';
import PlusSign from '@src/editor/components/PlusSign';
import ColorBoxWithPicker from './ColorBoxWithPicker';
import { uuid } from '@src/utils';
import SpacingSize from './SpacingSize';
import { colors } from './colorList';
import { Colors } from '@src/styles';
import BoxShadow from '@src/editor/Settings/Styles/BoxShadow';
import Border from '@src/editor/Settings/Styles/Border';
const Wrapper = styled.div `
  padding: 24px;
  flex: 1;
  overflow: scroll;
  max-height: 100vh;
`;
const ColorWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const AddBox = styled.div `
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7%;
  margin-left: 10px;
  vertical-align: middle;
  line-height: 45px;
  background-color: rgb(240, 240, 240);
  color: rgb(152, 161, 164);
  padding: 8px;
  transition: all 200ms ease;

  &:hover {
    background-color: ${Colors.accent};
    color: white;
  }
`;
const SpacingWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
`;
const onAddColorClick = () => {
    const id = uuid();
    const randomColor = Object.assign(Object.assign({}, colors[Math.floor(Math.random() * colors.length)]), { id });
    stateUi.editingColorId = id;
    stateSettings.colors.push(randomColor);
};
const onAddBoxShadowClick = () => {
    stateSettings.boxShadow.push({
        id: uuid(),
        value: '0 10px 20px hsla(0, 0%, 0%,.15), 0 3px 6px hsla(0, 0%, 0%, .10);',
    });
};
const onAddBorderClick = () => {
    stateSettings.border.push({
        id: uuid(),
        radius: '80px 149px 80px 51px',
        style: '2px solid #f78888',
    });
};
const ColorsAndSpacing = () => (React.createElement(Wrapper, null,
    React.createElement(H1, null,
        "Colors",
        React.createElement(AddBox, { onClick: onAddColorClick },
            React.createElement(PlusSign, null))),
    React.createElement(ColorWrapper, null, stateSettings.colors.map((color) => (React.createElement(ColorBoxWithPicker, { editing: stateUi.editingColorId === color.id, key: color.id, color: color })))),
    React.createElement(H1, null, "Spacing"),
    React.createElement(SpacingWrapper, null, stateSettings.spacing.map((spacing, index) => (React.createElement(SpacingSize, { index: index, spacing: spacing, key: `boxShadow_${index}` })))),
    React.createElement(H1, null,
        "Box Shadow",
        React.createElement(AddBox, { onClick: onAddBoxShadowClick },
            React.createElement(PlusSign, null))),
    React.createElement(SpacingWrapper, null, stateSettings.boxShadow.map((boxShadow, index) => (React.createElement(BoxShadow, { boxShadow: boxShadow, key: `boxShadow_${index}` })))),
    React.createElement(H1, null,
        "Borders",
        React.createElement(AddBox, { onClick: onAddBorderClick },
            React.createElement(PlusSign, null))),
    React.createElement(SpacingWrapper, null, stateSettings.border.map((border, index) => (React.createElement(Border, { border: border, key: `border_${index}` }))))));
export default ColorsAndSpacing;
